export default __webpack_public_path__ + "static/media/smart-search.73c928f1.svg";